/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define(['jquery'], function ($) {
	class Ajax {
		constructor() {
		}
		getAPI() {
			return {
				ajax: (request) => {
					return $.ajax(request);
				}
			};
		}
	}
	return Ajax;
});
